function isSameDateTimeToSecond(date1, date2) {
    // Para los items nos intersa muoho poner el id en diferentes horas porque compara por horas en reservas de mismo calendario mismo dia 
    const normalize = (str) => {
        const [datePart, timePart] = str.trim().split(' ');
        const [year, month, day] = datePart.split('-').map(n => n.padStart(2, '0'));
        const [hour = '00', minute = '00', second = '00'] = (timePart || '').split(':').map(n => n.padStart(2, '0'));
        return new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`);
    };

    const d1 = normalize(date1);
    const d2 = normalize(date2);

    return d1.getFullYear() === d2.getFullYear() &&
           d1.getMonth() === d2.getMonth() &&
           d1.getDate() === d2.getDate() &&
           d1.getHours() === d2.getHours() &&
           d1.getMinutes() === d2.getMinutes() &&
           d1.getSeconds() === d2.getSeconds();
}


function isSameDate(date1, date2) {
    // cuidado con el formato de fechas a veces no pone el cero a la derecha de la fechas
    const normalize = (str) => {
        // Pad month and day with leading zeros if missing
        let [datePart] = str.split(" ");
        let [year, month, day] = datePart.split("-").map(num => num.padStart(2, '0'));
        return `${year}-${month}-${day}`;
    };

    return normalize(date1) === normalize(date2);
}

function isEqualItem(existingItem, updatedItem) {
    return (
        existingItem.id_experience === updatedItem.id_experience
        && existingItem.id_calendario === updatedItem.id_calendario
        && isSameDateTimeToSecond(existingItem.start, updatedItem.start)
    )
}

export function isEqualFied(existingField, updatedField) {
    return (
        (updatedField.id_custom_fields_options && existingField.id_custom_fields_options 
            && updatedField.id_custom_fields_options === existingField.id_custom_fields_options
            && updatedField.title === existingField.title
        ) ||
        (existingField.title === updatedField.title)
    );
}

export function mergeCheckout(existingCheckout, updatedCheckout, update = false) {
    /*
    Para que funcione correctamente solo se debe de añadir el id que manda el backedn y por demas se van
    a mantener los datos del estado. Esto se hace así porque el backedn y el frontend manejan datos diferentes
    La primera vez que se busca se va a hacer por title y una vez identificado ese id se usa el id que manda el backend
    */

    const checkout = {
        ...existingCheckout,
        ...updatedCheckout,
        items: existingCheckout.items.map(existingItem => {
            const updatedItem = updatedCheckout.items.find(updatedItem => isEqualItem(existingItem, updatedItem));

            if (!updatedItem) {
                console.log(`Existing item is not with id_experience: ${existingItem.id_experience} and id_calendar ${existingItem.id_calendario} is not updated`);
                return existingItem;
            }

            return {
                ...existingItem,
                ...updatedItem,
                fields: existingItem.fields.map(existingField => {
                    const updatedField = updatedItem.fields.find(updatedField => isEqualFied(existingField, updatedField));

                    if (!updatedField) {
                        console.log(`Existing field is not with id_custom_fields_options: ${existingField.id_custom_fields_options} and title ${existingField.title} is not updated`);
                        return existingField;
                    }

                    return {
                        ...updatedField, // Añade el id del serviridor
                        ...existingField, // Mantiene los datos del estado del servidor para tener consistencia
                    };

                })
            }
        })


    }


    console.log("El resultado del checkoit es:", checkout);

    return checkout;
}

export function addsIdCustomFieldsOptions(items) {
    return items.map(item => {
        const data = {
            ...item,
            fields: item.fields.map(field => {
                return {
                    ...field,
                    id_custom_fields_options: field.id,
                    options: field.options.map(option => {
                        return {
                            ...option,
                            id_custom_fields_options: option.id,
                        }
                    })
                }
            })
        }

        return data;
    })
}

export function adaptRequest(checkout, experiences) {
    /*
      SOLO PARA EXPERIENCIAS DE TIPO MULTPRICE
      Por cosas del backedn es necesario eliminar los id de los campos a apartir del segundo item si tiene campos de tipo por persona
      Si los campos son de tipo por reserva += si deben mantener el id

      Para los campos de tipo += los icampos a partir del segundo item
      deben de llevar id pero no debe ser el mismo que del primer item 
      pero en siguentes peticiones debe de mantenerse
      Para que sea mas simple simplemente lo que se hace es que se elimina el id de de los field a partir del segudno item qie no sean de tipo += 

      PARA LOS QUE NO SON MULTIPRICE SE DEBEN DE MANTENER TODOS LOS IDS
    */

    // Elimina los ids
    for (let i = 1; i < checkout.items.length; i++) {
        const item = checkout.items[i];

        if (!item) {
            break;
        }

        let experience = experiences.find(experience => experience.id === item.id_experience);

        if (experience.price_type === 'multi_price') {
            // SOLO SI ES MULTIPRICE SE ELIMINAN LOS IDS POR SOLICITUDD DEL BACKEND
            for (let field of item.fields) {
                if (!field.name.includes("+=")) {
                    delete field.id;
                    delete field.id_custom_fields_options;
                }
            }
        }

    }

    // Para el lenguage solo si es multiprice nos tenemos que asegurar que tanto el lenguage general como el del los items sean el mismo
    checkout.items.forEach(item => {
        let experience = experiences.find(experience => experience.id === item.id_experience);
        if (!experience) return

        if (experience.price_type === 'multi_price') {
            item.language = checkout.language;
        }
    });


    return checkout
}


export function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r = Math.random() * 16 | 0
        const v = c === 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
    })
}